import { Repository } from "src/firebase/firestore/repository";
import { Room } from "../entities/room.entity";
import { RoomParticipant } from "../entities/room-participant.entity";
import { RoomAction } from "../entities/room-history.entity";
import { RoomMessage } from "../entities/room-message.entity";
import { collection, doc, query, orderBy, getDocs } from "firebase/firestore";
import { db } from "src/firebase";

class RoomRepository extends Repository<Room> {
  constructor() {
    super("rooms");
  }

  /**
   * Get participants sub-collection for a room
   */
  async getParticipants(roomId: string): Promise<RoomParticipant[]> {
    const participantsRef = collection(db, "rooms", roomId, "room_participants");
    const q = query(participantsRef, orderBy("joinedAt", "desc"));
    const snapshot = await getDocs(q);
    return snapshot.docs.map(doc => ({ ...doc.data(), id: doc.id } as RoomParticipant));
  }

  /**
   * Get history/actions sub-collection for a room
   */
  async getHistory(roomId: string): Promise<RoomAction[]> {
    const historyRef = collection(db, "rooms", roomId, "actions_history");
    const q = query(historyRef, orderBy("timestamp", "desc"));
    const snapshot = await getDocs(q);
    console.log("snapshot", snapshot.docs);
    return snapshot.docs.map(doc => ({ ...doc.data(), id: doc.id } as RoomAction));
  }

  /**
   * Get messages sub-collection for a room
   */
  async getMessages(roomId: string): Promise<RoomMessage[]> {
    const messagesRef = collection(db, "rooms", roomId, "room_messages");
    const q = query(messagesRef, orderBy("createdAt", "desc"));
    const snapshot = await getDocs(q);
    return snapshot.docs.map(doc => ({ ...doc.data(), id: doc.id } as RoomMessage));
  }

  /**
   * Get document reference for real-time subscription
   */
  getRoomDocRef(roomId: string) {
    return doc(db, "rooms", roomId);
  }

  /**
   * Get participants collection reference for real-time subscription
   */
  getParticipantsQuery(roomId: string) {
    const participantsRef = collection(db, "rooms", roomId, "participants");
    return query(participantsRef, orderBy("joinedAt", "desc"));
  }
}

export const roomRepository = new RoomRepository();
